import { Page } from "@/models/page-models/Page";

export const SpareParts: Page = {
  "path": "spare-parts",
  "name": "Spare Parts Master",
  "props": {
    "data": {
      "title": "Spare Parts Master",
      "printable": "FALSE",
      "url": "spare-parts",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Spare Part",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "redirectToCreateSparePart"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Spare Parts Master",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.allSpareParts}}",
                  "items": "fetchedData.allSpareParts.data.docs",
                  "headers": [
                    {
                      "value": "_id",
                      "text": "Spare Part #"
                    },
                    {
                      "value": "description",
                      "text": "Description"
                    },
                    {
                      "value": "specification",
                      "text": "Specification"
                    },
                    {
                      "value": "category",
                      "text": "Category"
                    },
                    {
                      "value": "unit",
                      "text": "Unit"
                    },
                    {
                      "value": "unitPrice",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,currency,{{__item.unitPrice}})"
                    },
                    {
                      "value": "actions",
                      "text": "Actions",
                      "type": "actions",
                      "actions": [
                        {
                          "label": "View",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "viewSparePart"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "tableType": "static",
                  "showActions": true,
                  "pagination": {
                    "pageVariable": "fetchedData.sparePartForm.page",
                    "serverItemsLengthVariable": "fetchedData.allSpareParts.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "getSpareParts",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v2/sparepart",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.allSpareParts",
                          "arg3Key": "postData",
                          "arg3Value": "fetchedData.sparePartForm"
                        },
                        "name": "getSpareParts"
                      }
                    ]
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaulltSparePartForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaulltSparePartForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.sparePartForm"
        },
        "name": "copyDefaulltSparePartForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getSpareParts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/sparepart",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.allSpareParts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.sparePartForm"
        },
        "name": "getSpareParts"
      }
    ],
    "functions": [
      {
        "name": "redirectToCreateSparePart",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "spare-parts/create"
      },
      {
        "name": "viewSparePart",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "spare-parts/{{__item._id}}"
      },
      {
        "name": "getDefaulltSparePartForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "paginate": "true"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER",
  "visible": true
}